/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/5/2023
 */

import { Menu } from "@mui/icons-material";
import {
  Box,
  IconButton,
  ListItemText,
  MenuItem,
  MenuList,
  SwipeableDrawer,
} from "@mui/material";
import React, { useState } from "react";
import styles from "./NavBar.module.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Store/Slices/authSlice";

const DrawerMenu = () => {
  const dispatch = useDispatch();

  const [position, setPosition] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setPosition({ ...position, [anchor]: open });
  };

  const onLogout = () => {
    dispatch(logout());
    window.location.reload();
  };

  const links = [
    { id: 1, name: "Home", link: "/" },
    { id: 2, name: "Services", link: "/services" },
    { id: 3, name: "About Us", link: "/aboutUs" },
    { id: 4, name: "Contact Us", link: "/contact" },
  ];

  const list = (anchor) => (
    <Box
      className={styles.menuContainer}
      style={{ width: '12rem' }}

      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {/* <img className={styles.image} alt='logo' src={`${process.env.REACT_APP_IMAGE_URL}E_SERVICE/logo.png`}/> */}
      <img
        style={{ height: "4rem", paddingLeft: "1rem" }}
        alt="logo"
        src={`${process.env.REACT_APP_IMAGE_URL}DoneRight/HOME/doneRightLogo.png`}
        loading="lazy"
      />
      {/* <img style={{height: '5rem', paddingTop: '1rem'}} alt="logo" src={`${process.env.REACT_APP_IMAGE_URL}Defalut/n-ach logo 1.png`}/> */}
      <MenuList className={styles.listContainer}>
        {links.map((item) => (
          <Link key={item.id} className={styles.link} to={item.link}>
            <MenuItem key={item.link}>
              <ListItemText>{item.name}</ListItemText>
            </MenuItem>
          </Link>
        ))}
        {/* {!isSignIn ? (
          <Link to="/login">
            <MenuItem className={styles.link}>
              <ListItemText>Log in</ListItemText>
            </MenuItem>
          </Link>
        ) : null}
        {isSignIn ? (
          <MenuItem onClick={onLogout} className={styles.link}>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        ) : null} */}
      </MenuList>
    </Box>
  );

  return (
    <div className={styles.menu}>
      <IconButton
        onClick={toggleDrawer("left", true)}
        style={{ marginLeft: "0" }}
      >
        <Menu />
      </IconButton>
      <SwipeableDrawer
        anchor={"left"}
        open={position["left"]}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {list("left")}
      </SwipeableDrawer>
    </div>
  );
};

export default DrawerMenu;
